import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Row, Col } from 'react-bootstrap';
import FontAwesome from 'react-fontawesome';
import { getDefaultCalendarView, dateRangeByView } from './calendarView/Calendar';
import Calendar from './IndividualConsultationCalendar';
import BookingOptions from './IndividualConsultationBookingOptions';
import { withTranslation } from 'react-i18next';

class IndividualConsultationClass extends Component {
	constructor(props) {
		super(props);

		this.handleCalendarNavigate = this.handleCalendarNavigate.bind(this);

		this.state = {
			selectedDate: new Date()
		};
	}

	componentDidMount() {
		if (this.props.bookingOptions.date) {
			this.props.onSaveBooking();			// consultation date is already selected, continue to Confirm
		} else {
			this.handleCalendarNavigate(this.getCalendarInitialDate());
		}
	}

	getCalendarInitialDate() {
		const center = this.props.selectedCenter;
		return center && center.individualConsultationStartDate ? new Date(center.individualConsultationStartDate) : new Date();
	}

	handleCalendarNavigate(date) {
		this.setState({ selectedDate: date });
		const { from, to } = dateRangeByView(getDefaultCalendarView(true), date);
		this.props.onCalendarNavigate(from, to);
	}

	render() {
		const { bookingOptions: { date }, t } = this.props;

		return (
			<div>
				<div className={`steps_title ${date ? 'hidden-xs' : ''}`}>{t('FO_Booking_IndividualConsultationDate_Message')}</div>
				<div className='info-message' dangerouslySetInnerHTML={{ __html: t('FO_IndividualConsultationSearch_InfoMessage_html') }} />
				<div className={date ? 'calendar-container hidden-xs' : 'calendar-container'}>
					<div style={{ padding: '10px', background: '#fff', border: '1px solid #ddd', borderTop: 'none' }}>
						<Calendar
							date={this.state.selectedDate}
							initialDate={this.getCalendarInitialDate()}
							center={this.props.selectedCenter}
							schedule={this.props.schedule}
							enableUserTimeZone={this.props.enableUserTimeZone}
							onNavigate={this.handleCalendarNavigate}
							onSelectConsultationDate={this.props.onSelectConsultationDate}
							calendarBlock={this.props.calendarBlock}
							calendarUnblock={this.props.calendarUnblock}
						/>
					</div>
					<Row style={{ paddingTop: '10px' }}>
						<Col sm={12}>
							<Button className='btn btn-back btn-block-xxs' onClick={this.props.onNavigateBack}><FontAwesome name='arrow-circle-left' /> {t('FO_Booking_Center_Select')}</Button>
						</Col>
					</Row>
				</div>
				<div className={!date ? 'booking-options-container hidden-xs' : 'booking-options-container'}>
					<BookingOptions
						children={this.props.children}
						center={this.props.selectedCenter}
						enableUserTimeZone={this.props.enableUserTimeZone}
						bookingOptions={this.props.bookingOptions}
						onCancel={this.props.onUnselectConsultationDate}
						onSelectChild={this.props.selectChild}
						onConfirm={this.props.onSaveBooking}
						enableCurrencyConversion={this.props.enableCurrencyConversion}
						currentCurrency={this.props.currentCurrency}
						franchisorCurrency={this.props.franchisorCurrency}
					/>
				</div>
			</div>
		);
	}
}

IndividualConsultationClass.propTypes = {
	individualConsultationSchedule: PropTypes.arrayOf(PropTypes.shape({
		start: PropTypes.string,
		end: PropTypes.string
	})),
	onCalendarNavigate: PropTypes.func.isRequired,
	onSelectConsultationDate: PropTypes.func.isRequired,
	onUnselectConsultationDate: PropTypes.func.isRequired,
	onSaveBooking: PropTypes.func.isRequired,
	onNavigateBack: PropTypes.func.isRequired,
	selectedCenter: PropTypes.shape({
		id: PropTypes.number,
		name: PropTypes.string,
		address: PropTypes.string,
		addressDescription: PropTypes.string,
		phoneNumber: PropTypes.string,
		additionalInfo: PropTypes.string,
		latitude: PropTypes.number,
		longitude: PropTypes.number,
		individualConsultationStartDate: PropTypes.string,
		individualConsultationFirstPrice: PropTypes.string,
		individualConsultationPrice: PropTypes.string
	}),
	children: PropTypes.arrayOf(PropTypes.shape({
		shortName: PropTypes.string,
		hasIndividualConsultation: PropTypes.boolean
	})),
	showIndividualConsultation: PropTypes.bool,
	enableUserTimeZone: PropTypes.bool
};

export default withTranslation()(IndividualConsultationClass);